import React from 'react';
import Header from '../../Layout/Header';
import Footer from '../../Layout/Footer';
import FAQ from './FAQ';
import SeoTagsFooter from './SeoTagsFooter';

function FastagRechargeApi() {
  const faqs = [
    {
      question: "What is Mokshiq FASTag Recharge API?",
      answer: "Mokshiq FASTag Recharge API (by Rakle Service Private Limited) allows retailers and mobile apps to process instant FASTag toll recharges for all major issuing banks across India."
    },
    {
      question: "Which FASTag banks are supported?",
      answer: "We support Paytm FASTag, ICICI Bank, HDFC Bank, SBI, Axis Bank, IDFC First, IndusInd, and Kotak Mahindra FASTags."
    }
  ];

  return (
    <div className="page_wrapper">
      <Header />
      <main className="page_content">
        <section className="page_header text-center bg-dark section_decoration overflow-hidden py-5" style={{ backgroundImage: "url('assets/images/backgrounds/page_header_bg_1.webp')" }}>
          <div className="container">
            <span className="badge bg-warning text-dark px-3 py-2 text-uppercase mb-3 font-weight-bold" style={{ letterSpacing: '1px' }}>
              <i className="fa-solid fa-car me-2"></i>NETC FASTag API
            </span>
            <h1 className="page_title text-white mb-3">FASTag Toll Recharge API</h1>
            <p className="text-white-50 mx-auto" style={{ maxWidth: '750px' }}>
              Instant multi-bank FASTag toll wallet top-ups powered by <strong>Rakle Service Private Limited</strong>.
            </p>
            <ul className="breadcrumb_nav unordered_list justify-content-center mt-3">
              <li><a href="/">Home</a></li>
              <li><a href="/services">Recharge APIs</a></li>
              <li className="active"><a href="#!">FASTag Recharge API</a></li>
            </ul>
          </div>
        </section>

        <section className="section_space bg-white">
          <div className="container">
            <div className="row g-4">
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-car-side text-primary fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Vehicle Registration Fetch</h3>
                  <p className="text-muted small">Fetch FASTag issuer bank and registered owner name using vehicle registration number.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-bolt text-warning fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Instant Wallet Top-Up</h3>
                  <p className="text-muted small">Real-time NPCI toll tag credit with instant digital SMS confirmation to vehicle owner.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-percent text-success fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Attractive Commission</h3>
                  <p className="text-muted small">Earn high commissions on every FASTag top-up transaction processed through your wallet.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FAQ faqList={faqs} title="FASTag Recharge FAQs" subtitle="Frequently asked questions about FASTag toll recharge API integration." />
      </main>
      <Footer />
      <SeoTagsFooter />
    </div>
  );
}

export default FastagRechargeApi;
